export default __webpack_public_path__ + "static/media/pubg-cover.e62de41a.png";